import React, { memo, useEffect, useMemo, useState } from 'react';
import cn from 'classnames';

import { Spinner } from 'components/Spinner/Spinner.component';

import styles from './PDF.module.scss';

export interface PDFProps {
  /** Custom class name */
  className?: string;
  /** Custom style */
  style?: Record<string, unknown>;
  /** PDF source */
  url: string;
}

export const PDF: React.FC<PDFProps> = memo(
  ({
    className = '', // custom class name
    style, // custom style
    url,
  }: PDFProps) => {
    const contentClassNames = cn(
      {
        [styles.PDF]: true,
      },
      className
    );
    const [showLoader, setShowLoader] = useState<boolean>(true);
    const isPDF = useMemo(() => {
      if (url.toLowerCase().endsWith('.pdf')) {
        return true;
      } else return false;
    }, [url]);

    useEffect(() => {
      setShowLoader(true);
    }, [url]);

    useEffect(() => {
      if (!isPDF) setShowLoader(false);
    }, [isPDF]);

    const filetype = url?.split('.').pop();

    const hideLoader = () => {
      setShowLoader(false);
    };

    return (
      <div className={contentClassNames} style={style} data-testid="PDF">
        {showLoader && (
          <div className={styles.PDFLoader}>
            <Spinner size="xsmall" />
          </div>
        )}
        <iframe
          className={cn(filetype, styles['iframe'], {
            [styles['hidden']]: showLoader,
          })}
          // This will only work on both desktop and mobile browser but it is slow
          // src={`https://docs.google.com/gview?embedded=true&url=${url}`}
          // This only work on desktop browser and for PDF but it is fast as it doesn't needs to download viewer.
          // src={`${url}#toolbar=0`}
          src={
            isPDF
              ? `${url}#toolbar=0`
              : `https://docs.google.com/gview?embedded=true&url=${url}`
          }
          onLoad={hideLoader}
        ></iframe>
      </div>
    );
  }
);

PDF.displayName = 'PDF';
